import {XauditModel} from '../xaudit.model';
import {PredefinedNoteDataModel} from './predefined-note-data.model';

export class PredefinedNoteSetDataModel extends XauditModel {
  NoteSetId: string;
  NoteSetName: string;
  NoteSetType: string;
  NoteSetOrder: number;
  public dataPredefinedNotes: PredefinedNoteDataModel[];
}
